var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-input',{ref:"input",attrs:{"placeholder":_vm.placeholder || _vm.$t('search'),"allowClear":true},on:{"change":_vm.handleSearch},model:{value:(_vm.inputValue),callback:function ($$v) {_vm.inputValue=$$v},expression:"inputValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }